import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useCallback } from 'react';

import type { TDadataFullNameSuggest } from 'shared/types/TDaData';
import { FullNameField } from 'shared/ui/FullNameField';

import type { TAdditionalDataFormFields } from 'entities/creditForm';

export const AdditionalPhoneOwnerFioField: FC<IFieldFactoryProps> = ({ ...props }) => {
  const { getValues, setValue } = useFormContext<TAdditionalDataFormFields>();

  const onInitialSuggestsLoad = useCallback(
    (option: Dictionaries.TSelectOption<string, TDadataFullNameSuggest['data']>) => {
      setValue('additionalPhoneOwnerFullName', option, { shouldValidate: true });
    },
    [setValue],
  );

  return (
    <FullNameField
      {...props}
      initialFioValue={String(getValues('additionalPhoneOwnerFullName')?.value || '')}
      onInitialSuggestsLoad={onInitialSuggestsLoad}
    />
  );
};
